import React from "react";
import { Box, Typography, Button, Grid, useMediaQuery } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

const Home = () => {
    const navigate = useNavigate();
    const { t } = useTranslation();
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

    return (
        <Box
            sx={{
                minHeight: "100vh",
                backgroundColor: "#FFF5E1",
                color: "#333",
                padding: 4,
            }}
        >
            {/* Hero Section */}
            <Box
                sx={{
                    backgroundImage: "url('/images/banner.jpg')",
                    backgroundRepeat: "no-repeat",
                    backgroundColor: "Grey",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "center",
                    textAlign: "center",
                    padding: 4,
                    borderRadius: 2,
                    minHeight: '50vh',

                    ...(isMobile
                        ? { // Mobile Styles
                            height: "100vh", // Full viewport height
                            backgroundSize: "cover", // Cover the entire viewport
                            backgroundPosition: "center 50%", // Center the image
                        }
                        : { // Desktop Styles
                            width: "100%", // Full width
                            height: "100%", // Full height.
                            backgroundSize: "cover", // Cover the entire element.
                            backgroundPosition: "center 45%", // Center the image.
                        }),
                }}
            >
                <Typography
                    variant="h3"
                    sx={{
                        fontWeight: "bold",
                        color: "#fff",
                        textShadow: "1px 1px 0 #000, -1px 1px 0 #000, 1px -1px 0 #000, -1px -1px 0 #000",
                    }}
                >
                    {t("Home.welcome")}
                </Typography>
                <Typography
                    variant="h6"
                    sx={{
                        mt: 2,
                        maxWidth: 600,
                        color: "#fff",
                        textShadow: "1px 1px 0 #000, -1px 1px 0 #000, 1px -1px 0 #000, -1px -1px 0 #000",
                    }}
                >
                    {t("Home.tagline")}
                </Typography>
                <Button
                    variant="contained"
                    color="primary"
                    sx={{ mt: 3, fontSize: "1.2rem" }}
                    onClick={() => navigate("/application")}
                >
                    {t("Home.apply_now")}
                </Button>
            </Box>

            {/* About Section */}
            <Box sx={{ mt: 6, textAlign: "center", cursor: 'pointer' }} onClick={() => navigate('/about')}> {/* Add onClick and cursor */}
                <Typography variant="h4" sx={{ fontWeight: "bold" }}>
                    {t("Home.about_us")}
                </Typography>
                <Typography variant="body1" sx={{ mt: 2, maxWidth: 800, margin: "auto", textAlign: "left" }}>
                    {t("Home.about_description")}
                </Typography>
            </Box>

            {/* Highlights Section */}
            <Box sx={{ mt: 6 }}>
                <Typography variant="h4" sx={{ fontWeight: "bold", textAlign: "center" }}>
                    {t("Home.why_choose_us")}
                </Typography>
                <Grid container spacing={4} sx={{ mt: 4 }}>
                    <Grid item xs={12} md={4}>
                        <Box
                            sx={{
                                backgroundColor: "white",
                                borderRadius: 2,
                                boxShadow: 2,
                                padding: 3,
                                textAlign: "center",
                            }}
                        >
                            <Typography variant="h5" sx={{ fontWeight: "bold", mb: 2 }}>
                                {t("Home.academic_support")}
                            </Typography>
                            <Typography variant="body1" sx={{ textAlign: "left" }}>{t("Home.academic_description")}</Typography>
                        </Box>
                    </Grid>
                    <Grid item xs={12} md={4}>
                        <Box
                            sx={{
                                backgroundColor: "white",
                                borderRadius: 2,
                                boxShadow: 2,
                                padding: 3,
                                textAlign: "center",
                            }}
                        >
                            <Typography variant="h5" sx={{ fontWeight: "bold", mb: 2 }}>
                                {t("Home.modern_amenities")}
                            </Typography>
                            <Typography variant="body1" sx={{ textAlign: "left" }}>{t("Home.modern_amenities_description")}</Typography>
                        </Box>
                    </Grid>
                    <Grid item xs={12} md={4}>
                        <Box
                            sx={{
                                backgroundColor: "white",
                                borderRadius: 2,
                                boxShadow: 2,
                                padding: 3,
                                textAlign: "center",
                            }}
                        >
                            <Typography variant="h5" sx={{ fontWeight: "bold", mb: 2 }}>
                                {t("Home.english")}
                            </Typography>
                            <Typography variant="body1" sx={{ textAlign: "left" }}>{t("Home.english_description")}</Typography>
                        </Box>
                    </Grid>
                </Grid>
            </Box>
        </Box>
    );
};

export default Home;
